export const facilityData = {
    facilityCode    : 1001,
    facilityName    : '椿泊漁業協同組合',
    logoUrl         : '/images/logo_tks.svg',
    logoUrl_trafic  : '/images/logo_tks_trafic.svg',
    logoUrl_hygiene : '/images/logo_tks_hygiene.svg'
}

export const authorityList = [
    { id: '1', name: 'システム管理者' },
    { id: '2', name: '漁協ユーザ' },
    { id: '3', name: '仲買ユーザ' },
    { id: '4', name: '漁業者' },
]

export const styleList = [
    { id: '1', name: 'D' },
    { id: '2', name: '箱' },
]

export const kgDivision = [
    { id: '0', name: '箱' },
    { id: '1', name: 'Kg' },
    { id: '2', name: '本' },
    { id: '3', name: '匹' },
    { id: '4', name: '袋' },
]

export const fishStyleList = [
    { id: '0', name: '鮮魚' },
    { id: '1', name: '活魚' },
]

export const bidUnitList = [
    { id: '1', name: '全量' },
    { id: '2', name: 'Kg' },
    { id: '3', name: 'D' },
    { id: '4', name: '箱' },
    { id: '5', name: '匹' },
]

export const lineList = [
    { id: '1', name: '1' },
    { id: '2', name: '2' },
    { id: '3', name: '3' },
    { id: '4', name: '4' },
    { id: '5', name: '5' },
    { id: '9', name: '他' },
]
export const searchLineList = [
    { id: '99', name: 'すべて' },
    { id: '1', name: '1' },
    { id: '2', name: '2' },
    { id: '3', name: '3' },
    { id: '4', name: '4' },
    { id: '5', name: '5' },
    { id: '9', name: '他' },
]
export const bidModeList = [
    { id: '0', name: 'プール' },
    { id: '1', name: '個別' },
]
export const exportList = [
    { id: '0', name: '水揚情報' },
    { id: '1', name: '荷受情報' },
    { id: '2', name: '共同売上情報' },
    { id: '3', name: '事務処理データ' },
]
export const exportTraderList = [
    { id: '4', name: '納品データ' },
]
export const slipPrintList = [
    { id: 0, name: '仕入明細' },
    { id: 1, name: '納品明細' },
]
export const dogList = [
    { id: '1', name: '1' },
    { id: '2', name: '2' },
    { id: '3', name: '3' },
    { id: '4', name: '4' },
    { id: '5', name: '5' },
]
export const tankManageList = [
    { id: 0, name: 'しない' },
    { id: 1, name: 'する' },
]